/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/filter_sync.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    filterSyncModule
} from "../../../grids/grid_core/filter/m_filter_sync";
import core from "../m_core";
core.registerModule("filterSync", filterSyncModule);
